export const HorariosBanner = () => {
  return (
    <section className="py-12 bg-gradient-to-r from-salbox-primary to-salbox-primary-600">
      <div className="container mx-auto px-4">
        <div className="text-center text-white">
          <div className="mb-6">
            <h2 className="text-3xl md:text-4xl font-lufga-semibold mb-4 uppercase">
              Nueva Ruta Especial - Los Arcos
            </h2>
            <p className="text-xl font-lufga opacity-95 max-w-3xl mx-auto">
              Este sábado estaremos en la zona de Los Arcos con comida caliente
              preparada al momento.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="flex items-center justify-center mb-4">
                <svg
                  className="w-8 h-8 mr-3"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z" />
                </svg>
                <h3 className="text-xl font-lufga-semibold">
                  Horario de Servicio
                </h3>
              </div>
              <p className="text-lg font-lufga">
                <strong>Sábado</strong>
                <br />
                11:30 a.m. a 3:00 p.m.
              </p>
              <p className="text-sm font-lufga opacity-90 mt-2">
                Nos movemos por la zona durante este horario
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
              <div className="flex items-center justify-center mb-4">
                <svg
                  className="w-8 h-8 mr-3"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <h3 className="text-xl font-lufga-semibold">
                  Zona de Cobertura
                </h3>
              </div>
              <p className="text-lg font-lufga">
                <strong>Los Arcos</strong>
                <br />y alrededores
              </p>
              <p className="text-sm font-lufga opacity-90 mt-2">
                Te avisamos cuando estemos cerca
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
